import * as React from 'react';
import { useOpenState } from 'app/infrastructure/hooks';
import { FavouriteInstance } from 'app/area/favourite/favourite-context';
import { ReportViewFavourite } from 'app/area/company-report/report-view-favourite';
import { reportTranslation } from 'app/area/company-report/constants';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { 
  useActionCreators,
  useLoadMetadataEffect,
  useSelectors,
  useTemplateFileHandlers
} from 'app/area/company-report/hooks';

interface ReportViewProps {
  companyReportId: number;
  editSavedFavourite: boolean;
  favouriteId: number;
}

export function ReportView({
  companyReportId,
  editSavedFavourite,
  favouriteId
}: ReportViewProps) {

  const translation = useTranslation(STATE.companyReport, reportTranslation);

  const sharedState = useSharedState();

  const {
    metadata,
    emails,
    fetchingReport,
    fetchingMetadata,
    emailsValidation
  } = useSelectors();

  const {
    setEmail
  } = useActionCreators();

  const {
    isOpen: showImportDocumentModal,
    onOpen: handleAddTemplate,
    onClose
  } = useOpenState();

  useLoadMetadataEffect(companyReportId);

  const {
    handleUploadTemplate,
    handleDownloadTemplate
  } = useTemplateFileHandlers(companyReportId);

  return (
    <FavouriteInstance>
      <ReportViewFavourite
        translation={translation}
        sharedState={sharedState}
        companyReportId={companyReportId}
        showImportDocumentModal={showImportDocumentModal}
        handleAddTemplate={handleAddTemplate}
        handleUploadTemplate={handleUploadTemplate}
        handleDownloadTemplate={handleDownloadTemplate}
        onClose={onClose}
        onChangeEmail={setEmail}
        metadata={metadata}
        emails={emails}
        fetchingReport={fetchingReport}
        fetchingMetadata={fetchingMetadata}
        emailsValidation={emailsValidation}
        editSavedFavourite={editSavedFavourite}
        favouriteId={favouriteId}
      />
    </FavouriteInstance>
  );
}
